import { Helmet } from "react-helmet-async";
 import { SubscriptionDetails } from "../../sections/subscription/index.js";

export default function SubscriptionDetailsPage(){
    return (
        <>
            <Helmet>
                <title>Subscription List Page</title>
            </Helmet>
            <SubscriptionDetails />
        </>
    )
}